// extracted by mini-css-extract-plugin
export default {"header":"ValueHeaderCard_header__2eO9n","percent":"ValueHeaderCard_percent__8LnoN","percentText":"ValueHeaderCard_percentText__f5qTd"};